import { Box } from '@mui/system'
import AdxPopper from 'components/reusable/AdxPopper'
import { useNavigate } from 'react-router-dom'
import { useState } from 'react'
import { Icon, Typography } from '@mui/material'
import CalendarDetailsModal from '../../recruitment-talent-calendar/components/CalendarDetailsModal'

const InterviewCandidatePopper = ({
  interviewData,
  id,
  type = 'reschedule',
  cancelInterviewModal,
  completeInterviewModal,
  noShowInterviewModal,
  candidateData,
  endDateObject,
  isLoading,
}) => {
  const navigate = useNavigate()
  const [open, setOpen] = useState(false)

  const handleToggle = () => {
    setOpen((prev) => !prev)
  }

  if (type === 'reschedule') {
    return (
      <>
        <Box display="flex" alignItems="center" columnGap={2}>
          <AdxPopper placement="bottom-start" sx={{ marginTop: 1 }}>
            <Box onClick={handleToggle} sx={{ cursor: 'pointer' }}>
              View details
            </Box>
            <Box
              onClick={() =>
                navigate('/app/recruitment/schedule-interview/edit', {
                  state: {
                    is_edit: true,
                    ...interviewData,
                  },
                })
              }
            >
              Edit details
            </Box>
            <Box color="error.main" onClick={cancelInterviewModal}>
              Cancel interview
            </Box>
          </AdxPopper>
        </Box>
        <CalendarDetailsModal
          open={open}
          handleClose={handleToggle}
          data={interviewData}
          dateData={endDateObject}
          interviewSlotIsLoading={isLoading}
        />
      </>
    )
  } else if (type === 'pending') {
    return (
      <>
        <Box display="flex" alignItems="center" columnGap={2}>
          <AdxPopper customPopper placement="bottom-start" sx={{ marginTop: 1 }}>
            <Box
              display="flex"
              alignItems="center"
              padding={2}
              borderBottom={1}
              borderColor="gray-line.main"
              columnGap={2}
              sx={{
                cursor: 'pointer',
                '&:hover': {
                  backgroundColor: 'alternate.light',
                },
              }}
              onClick={completeInterviewModal}
            >
              <Icon sx={{ color: 'alternate.main' }}>check_circle_outline</Icon>
              <Typography>Mark as completed</Typography>
            </Box>
            <Box
              display="flex"
              alignItems="center"
              padding={2}
              borderBottom={1}
              borderColor="gray-line.main"
              columnGap={2}
              sx={{
                cursor: 'pointer',
                '&:hover': {
                  backgroundColor: 'alternate.light',
                },
              }}
              onClick={() =>
                navigate('/app/recruitment/schedule-interview/edit', {
                  state: {
                    is_edit: true,
                    ...interviewData,
                  },
                })
              }
            >
              <Icon sx={{ color: 'alternate.main' }}>calendar_month</Icon>
              <Typography>Edit or reschedule</Typography>
            </Box>
            <Box
              display="flex"
              alignItems="center"
              padding={2}
              borderBottom={1}
              borderColor="gray-line.main"
              columnGap={2}
              sx={{
                cursor: 'pointer',
                '&:hover': {
                  backgroundColor: 'light-yellow-01.main',
                },
              }}
              onClick={noShowInterviewModal}
            >
              <Icon sx={{ color: 'warning.main' }}>help_outline</Icon>
              <Typography>Candidate no-show</Typography>
            </Box>
            <Box
              display="flex"
              alignItems="center"
              padding={2}
              columnGap={2}
              sx={{
                cursor: 'pointer',
                '&:hover': {
                  backgroundColor: 'light-error.main',
                },
              }}
              onClick={cancelInterviewModal}
            >
              <Icon sx={{ color: 'error.main' }}>highlight_off</Icon>
              <Typography sx={{ color: 'error.main' }}>Cancel interview</Typography>
            </Box>
          </AdxPopper>
        </Box>
        <CalendarDetailsModal
          open={open}
          handleClose={handleToggle}
          data={interviewData}
          dateData={endDateObject}
          interviewSlotIsLoading={isLoading}
        />
      </>
    )
  } else if (type === 'reinterview') {
    return (
      <>
        <Box display="flex" alignItems="center" columnGap={2}>
          <AdxPopper placement="bottom-start" sx={{ marginTop: 1 }}>
            <Box onClick={handleToggle} sx={{ cursor: 'pointer' }}>
              View details
            </Box>
            <Box
              onClick={() => {
                navigate('/app/recruitment/schedule-interview', {
                  state: {
                    applicant_name: candidateData?.name,
                    email: candidateData?.email,
                    id,
                    profile_picture: candidateData?.profile_image_url,
                  },
                })
              }}
            >
              Reinterview
            </Box>
          </AdxPopper>
        </Box>
        <CalendarDetailsModal
          open={open}
          handleClose={handleToggle}
          data={interviewData}
          dateData={endDateObject}
          interviewSlotIsLoading={isLoading}
        />
      </>
    )
  }
}
export default InterviewCandidatePopper
